import connectionProxy from './connectionProxy'

export const getCabinetProducts = (id) =>
  connectionProxy.http.get(`/armarios/${id}`)



// WEBPACK FOOTER //
// ./src/api/cabinetProducts.js